import {useEffect, useRef} from 'react'
import useWindowSize from '../../utils/useWindowSize'

const LineCanvas = ({
    wrapperId,
    fromId,
    toId,
    drawVerticalLine = false,
    midLabel = '',
}) => {
    const canvasRef = useRef(null)
    const width = useWindowSize()

    useEffect(() => {
        const canvas = canvasRef.current
        const context = canvas.getContext('2d')
        const drawLine = () => {
            if (context) {
                // Xóa canvas trước khi vẽ lại
                context.clearRect(0, 0, canvas.width, canvas.height)

                // Lấy tọa độ của các phần tử
                const wrapperElement = document.getElementById(wrapperId)
                const fromElement = document.getElementById(fromId)
                const toElement = document.getElementById(toId)

                if (wrapperElement && fromElement && toElement) {
                    const wrapperRect = wrapperElement.getBoundingClientRect()
                    const fromRect = fromElement.getBoundingClientRect()
                    const toRect = toElement.getBoundingClientRect()
                    let cvTop = 0
                    let cvLeft = 0
                    let cvWidth = 0
                    let cvHeight = 0

                    if (drawVerticalLine) {
                        cvTop = fromRect.bottom - wrapperRect.top

                        cvWidth = Math.abs(toRect.right - fromRect.left)
                        cvLeft = fromRect.left - wrapperRect.left

                        cvHeight = toRect.bottom - fromRect.bottom
                    } else {
                        cvTop =
                            fromRect.top < toRect.top
                                ? fromRect.top - wrapperRect.top
                                : toRect.top - wrapperRect.top
                        cvLeft =
                            fromRect.left < toRect.left
                                ? fromRect.left - wrapperRect.left
                                : toRect.left - wrapperRect.left

                        cvWidth = Math.abs(toRect.right - fromRect.left)

                        let minY =
                            fromRect.top < toRect.top
                                ? fromRect.top
                                : toRect.top
                        let maxY =
                            fromRect.bottom > toRect.bottom
                                ? fromRect.bottom
                                : toRect.bottom
                        cvHeight = maxY - minY
                    }

                    canvas.style.top = `${cvTop}px`
                    canvas.style.left = `${cvLeft}px`
                    canvas.width = cvWidth
                    canvas.height = cvHeight
                    // Vẽ đường line
                    const fromHeight = fromRect.bottom - fromRect.top
                    const fromWidth = fromRect.right - fromRect.left
                    let fromX = fromRect.right - fromRect.left
                    let fromY = fromRect.top - cvTop - wrapperRect.top

                    const toHeight = toRect.bottom - toRect.top
                    const toWidth = toRect.right - toRect.left
                    let toX = cvWidth - (toRect.right - toRect.left)
                    let toY = toRect.top - cvTop - wrapperRect.top

                    if (drawVerticalLine) {
                        fromX = fromWidth / 2
                        fromY = fromRect.bottom - cvTop - wrapperRect.top
                        toX = cvWidth - toWidth / 2
                        toY = toRect.top - cvTop - wrapperRect.top
                    } else {
                        if (cvHeight > 100) {
                            if (fromRect.top < toRect.top) {
                                fromX = fromWidth / 2
                                fromY =
                                    fromRect.bottom - cvTop - wrapperRect.top

                                toX = cvWidth - toWidth / 2
                                toY = toRect.top - cvTop - wrapperRect.top
                            } else {
                                fromX = fromWidth / 2
                                fromY = fromRect.top - cvTop - wrapperRect.top

                                toX = cvWidth - toWidth / 2
                                toY = toRect.bottom - cvTop - wrapperRect.top
                            }
                        } else {
                            fromY =
                                fromRect.top -
                                cvTop -
                                wrapperRect.top +
                                fromHeight / 2
                            toY =
                                toRect.top -
                                cvTop -
                                wrapperRect.top +
                                toHeight / 2
                        }
                    }

                    context.beginPath()
                    context.moveTo(fromX, fromY)
                    context.lineTo(toX, toY)
                    context.strokeStyle = 'black'
                    context.lineWidth = 1
                    context.stroke()

                    // Vẽ đầu mũi tên
                    const drawArrowHead = (x, y, angle) => {
                        const arrowLength = 6
                        const arrowWidth = 7
                        context.beginPath()
                        context.moveTo(x, y)
                        context.lineTo(
                            x - arrowLength * Math.cos(angle - Math.PI / 6),
                            y - arrowLength * Math.sin(angle - Math.PI / 6),
                        )
                        context.moveTo(x, y)
                        context.lineTo(
                            x - arrowLength * Math.cos(angle + Math.PI / 6),
                            y - arrowLength * Math.sin(angle + Math.PI / 6),
                        )
                        context.strokeStyle = 'black'
                        context.lineWidth = 1
                        context.stroke()
                    }

                    const angle = Math.atan2(toY - fromY, toX - fromX)

                    // Vẽ mũi tên đầu
                    // drawArrowHead(fromX, fromY, angle + Math.PI)

                    // Vẽ dấu chấm tròn ở đầu đường
                    const drawCircle = (x, y) => {
                        const radius = 3
                        context.beginPath()
                        context.arc(x, y, radius, 0, 2 * Math.PI, false)
                        context.fillStyle = 'black'
                        context.fill()
                    }
                    // Vẽ dấu chấm tròn ở đầu đường
                    drawCircle(fromX, fromY)

                    // Vẽ mũi tên cuối
                    drawArrowHead(toX, toY, angle)

                    // Vẽ label ở giữa
                    if (midLabel) {
                        context.font = '12px Arial'
                        context.fillStyle = 'black'
                        context.textAlign = 'center'
                        context.textBaseline = 'middle'
                        const midX = (fromX + toX) / 2
                        const midY = (fromY + toY) / 2
                        context.fillText(midLabel, midX, midY)
                    }
                }
            }
        }
        drawLine() // Vẽ lần đầu tiên
    }, [drawVerticalLine, fromId, midLabel, toId, width, wrapperId])

    return (
        <>
            <canvas
                ref={canvasRef}
                id={`cv-f-${fromId}-t-${toId}`}
                style={{
                    position: 'absolute',
                    // background: 'var(--gray-100)',
                }}
            />
        </>
    )
}

export default LineCanvas
